export default class Nav {

    constructor() {
        this.resizeWindow();
        this.initNavigation();
    }

    resizeWindow() {
        let resizeTimer;
        window.addEventListener('resize', e => {
            if (resizeTimer) clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                this.initNavigation();
            }, 100, e);
        });
    }

    initNavigation() {
        const isDesktop = window.innerWidth >= 992; // lg breakpoint

        if (isDesktop) {
            this.desktopNav();
        } else {
            this.mobileNav();
        }
    }

    desktopNav() {
        // Remove mobile nav open class
        document.body.classList.remove('nav-open');

        // Reset burger button
        const burger = document.querySelector('#headerWrapper .btn-hamburger');
        if (burger) {
            burger.innerHTML = '<i class="icon-menu"></i> MENU';
        }

        // Remove all mobile click handlers
        document.querySelectorAll('header nav ul li').forEach(function (li) {
            const link = li.querySelector('a');

            if (li._mobileClickHandler) {
                link.removeEventListener('click', li._mobileClickHandler);
                li._mobileClickHandler = null;
            }
        });

        // Handle desktop dropdown hover
        document.querySelectorAll('header nav > ul > li').forEach(function (li) {
            const link = li.querySelector('a');
            const submenu = li.querySelector('ul');

            if (submenu) {
                // Desktop hover behavior
                li.addEventListener('mouseenter', function() {
                    li.classList.add('active');
                });

                li.addEventListener('mouseleave', function() {
                    // Only remove active if it's not the current page
                    if (!link.classList.contains('active')) {
                        li.classList.remove('active');
                    }
                });
            }
        });
    }

    mobileNav() {
        const burger = document.querySelector('#headerWrapper .btn-hamburger');

        if (!burger) return;

        burger.removeEventListener('click', this.handleClick);
        burger.addEventListener('click', this.handleClick);

        // First, remove any existing handlers
        document.querySelectorAll('header nav ul li').forEach(function (li) {
            const link = li.querySelector('a');
            if (li._mobileClickHandler) {
                link.removeEventListener('click', li._mobileClickHandler);
            }
        });

        // Handle ONLY top-level parent links with submenus
        document.querySelectorAll('header nav > ul > li').forEach(function (li) {
            const link = li.querySelector('a');
            const submenu = li.querySelector('ul');

            // Only add special handling if this top-level link has a submenu
            if (submenu) {
                const clickHandler = function(e) {
                    const isOpen = li.classList.contains('active');

                    if (isOpen) {
                        // Already open - allow navigation to parent page
                        // Don't prevent default, let the link work
                        link.classList.remove('open');
                        li.classList.remove('active');
                    } else {
                        // Not open yet - prevent navigation and open submenu
                        e.preventDefault();
                        e.stopPropagation();

                        // Close all other menus first
                        document.querySelectorAll('header nav > ul > li').forEach(function (otherLi) {
                            if(li !== otherLi) {
                                const otherLink = otherLi.querySelector('a');
                                otherLink.classList.remove('open');
                                otherLi.classList.remove('active');
                            }
                        });

                        // Open this menu
                        link.classList.add('open');
                        li.classList.add('active');
                    }
                };

                // Store handler reference
                li._mobileClickHandler = clickHandler;
                link.addEventListener('click', clickHandler);
            }
        });

        // Set active state for current page
        const activeLink = document.querySelector('header nav a.active');
        if (activeLink) {
            let currentLi = activeLink.parentElement;

            // Traverse up to find the top-level li
            while (currentLi && currentLi.tagName === 'LI') {
                // Check if this li is a direct child of nav > ul
                if (currentLi.parentElement && currentLi.parentElement.parentElement &&
                    currentLi.parentElement.parentElement.tagName === 'NAV') {
                    // This is the top-level li
                    currentLi.classList.add('active');
                    const parentLink = currentLi.querySelector('a');
                    if (parentLink) {
                        parentLink.classList.add('open');
                    }
                    break;
                }
                currentLi = currentLi.parentElement.parentElement;
            }
        }
    }

    handleClick(e) {
        e.preventDefault();
        const burger = document.querySelector('#headerWrapper .btn-hamburger');

        document.body.classList.toggle('nav-open');

        if (document.body.classList.contains('nav-open')) {
            burger.innerHTML = '<i class="icon-x"></i> ' + burger.dataset.close;
        } else {
            burger.innerHTML = '<i class="icon-menu"></i> MENU';
        }
    }
}
